export default __webpack_public_path__ + "static/media/Spray-Paints.933ee3b4.jpg";